import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISupplierProductAssortment, ISupplierProductAssortmentFormData } from '../cards/product/product-status-supplier/supplier-product-status.model';
import { IRetailerProductAssortmentFormData } from '../cards/product/product-assortment-retailer/retailer-product-assortment.model';

@Injectable({ providedIn: 'root' })
export class ProductStoreService {

  constructor(private _http: HttpClient) { }

  public save(productId: string, id: string, data: any): Observable<string> {
    return this._http.post<string>(`api/products/${productId}/store/supplier/${id || ''}`, data);
  }

  public delete(productId: string, id: string): Observable<string> {
    return this._http.delete<string>(`api/products/${productId}/store/${id}`);
  }

  public getGridData(productId: string) {
    return this._http.get<any[]>(`api/products/${productId}/store/supplier/griddata`);
  }

  public getFormData(productId: string) {
    return this._http.get<any[]>(`api/products/${productId}/store/supplier/formData`);
  }
}
